(function () {
  function isOwnUi(el) {
    if (!el || el.nodeType !== 1) return true;
    if (el.id === 'back-top' || el.id === 'dropdown-cart') return true;
    if (!el.closest) return false;
    return !!(
      el.closest('#dropdown-cart') ||
      el.closest('#back-top') ||
      el.closest('.translate-header') ||
      el.closest('.wrapper-overlay') ||
      el.closest('.footbar-fixed') ||
      el.closest('#shopify-section-halo-toolbar-mobile') ||
      el.closest('.halo-modal') ||
      el.closest('.loading-modal') ||
      el.closest('[data-cart-edit-modal]') ||
      el.closest('[data-ajax-cart-success]') ||
      el.closest('[data-quickview-modal]') ||
      el.closest('.wrapper-newsletter') ||
      el.closest('.popup-sidebar')
    );
  }

  function attrMatch(el) {
    var id = (el.id || '').toLowerCase();
    var className = (typeof el.className === 'string' ? el.className : '').toLowerCase();
    var src = ((el.src || el.getAttribute('src') || '') + '').toLowerCase();
    return (
      src.indexOf('salesmartly') !== -1 ||
      id.indexOf('ssq') !== -1 ||
      id.indexOf('ssc') !== -1 ||
      id.indexOf('ss-chat') !== -1 ||
      className.indexOf('ssq') !== -1 ||
      className.indexOf('ss-chat') !== -1
    );
  }

  function looksLikeChatWidget(el) {
    if (isOwnUi(el)) return false;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'META' || tag === 'NOSCRIPT') return false;
    if (attrMatch(el)) return true;

    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'absolute') return false;

    var rect = el.getBoundingClientRect();
    if (rect.width < 20 || rect.height < 20 || rect.width > 120 || rect.height > 140) return false;

    var vw = window.innerWidth;
    var vh = window.innerHeight;
    if (rect.right < vw - 120) return false;
    if (rect.bottom < vh - 320) return false;
    return true;
  }

  function markEl(el) {
    if (!el || el.getAttribute('data-cs-chat-widget') === '1') return;
    el.setAttribute('data-cs-chat-widget', '1');
  }

  function markChatWidgets() {
    var nodes = document.querySelectorAll(
      'iframe[src*="salesmartly"], iframe[src*="ssq"], [id*="ssq"], [id*="ssc"], [id*="ss-chat"], [class*="ssq"], [class*="ss-chat"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (!isOwnUi(nodes[i])) markEl(nodes[i]);
    }

    if (!document.body) return;
    var children = document.body.children;
    for (var j = 0; j < children.length; j++) {
      if (looksLikeChatWidget(children[j])) markEl(children[j]);
    }
  }

  function setChatWidgetsHidden(hidden) {
    markChatWidgets();
    var widgets = document.querySelectorAll('[data-cs-chat-widget]');
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].closest && (widgets[i].closest('.halo-modal') || widgets[i].classList.contains('halo-modal') || widgets[i].classList.contains('loading-modal'))) {
        continue;
      }
      widgets[i].style.display = hidden ? 'none' : '';
      widgets[i].style.visibility = hidden ? 'hidden' : '';
      widgets[i].style.pointerEvents = hidden ? 'none' : '';
    }

    window.__ssc = window.__ssc || {};
    window.__ssc.setting = window.__ssc.setting || {};
    window.__ssc.setting.hideIcon = hidden;

    if (window.ssq && typeof window.ssq.push === 'function') {
      try {
        if (hidden) window.ssq.push('chatClose');
      } catch (e) {}
    }
  }

  function positionBackToTop(height) {
    var el = document.getElementById('back-top');
    if (!el) return;
    var h = parseInt(height, 10);
    if (!h || h < 48) h = 140;
    el.style.setProperty('bottom', h + 16 + 'px', 'important');
    el.style.setProperty('right', '20px', 'important');
    el.style.setProperty('left', 'auto', 'important');
  }

  function initSaleSmartlyPosition() {
    if (!window.ssq || typeof window.ssq.push !== 'function') return false;
    window.ssq.push('onReady', function () {
      window.ssq.push('getSidebarHeight', function (height) {
        positionBackToTop(height);
      });
    });
    return true;
  }

  function syncCartState() {
    var cartOpen = document.documentElement.classList.contains('cart-show');
    setChatWidgetsHidden(cartOpen);
  }

  function start() {
    markChatWidgets();
    initSaleSmartlyPosition();
    syncCartState();

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      markChatWidgets();
      syncCartState();
      if (initSaleSmartlyPosition() || tries > 20) {
        clearInterval(timer);
      }
    }, 500);

    var htmlObserver = new MutationObserver(syncCartState);
    htmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    if (document.body) {
      var bodyObserver = new MutationObserver(function () {
        markChatWidgets();
        syncCartState();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
